import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {BnbaccessBoSharedModule} from '../../shared';

import {
    HebergementBnbaccessComponent,
    HebergementBnbaccessDeleteDialogComponent,
    HebergementBnbaccessDeletePopupComponent,
    HebergementBnbaccessDetailComponent,
    HebergementBnbaccessDialogComponent,
    HebergementBnbaccessPopupService,
    HebergementBnbaccessService,
    hebergementPopupRoute,
    hebergementRoute,
} from './';
import {DroitComponent, DroitPopupComponent} from './droit/droit.component';
import {DroitService} from './droit/droit.service';

let ENTITY_STATES = [
    ...hebergementRoute,
    ...hebergementPopupRoute,
];

@NgModule({
    imports: [
        BnbaccessBoSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        HebergementBnbaccessComponent,
        HebergementBnbaccessDetailComponent,
        HebergementBnbaccessDialogComponent,
        HebergementBnbaccessDeleteDialogComponent,
        HebergementBnbaccessDeletePopupComponent,
        DroitComponent,
        DroitPopupComponent
    ],
    entryComponents: [
        HebergementBnbaccessComponent,
        HebergementBnbaccessDialogComponent,
        HebergementBnbaccessDeleteDialogComponent,
        HebergementBnbaccessDeletePopupComponent,
        DroitComponent,
        DroitPopupComponent
    ],
    providers: [
        HebergementBnbaccessService,
        HebergementBnbaccessPopupService,
        DroitService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BnbaccessBoHebergementBnbaccessModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/hebergement/hebergement-bnbaccess.module.ts